import {RouteInfo} from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/loans',
    title: 'Loans',
    icon: 'mdi mdi-cash-multiple',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/profile',
    title: 'Profile',
    icon: 'mdi mdi-account',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/application',
    title: 'Application Status',
    icon: 'mdi mdi-application',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: []
  }
];

